<template>
    <div class="Scan">
        <div v-if="!isCordova" class="scanner">
            <!--網頁-->
            <qrcode-stream v-if="isWebScan" @decode="onDecode" @init="onInit" @error="onError"/>
            <div class="mask"></div>
            <div class="scan_text">將鏡頭對準QRcode進行掃描</div>
            <button class="el-button back el-button--text" @click="finish">
                <span><img src="@/assets/images/top_bar_close_white.svg"></span>
            </button>
        </div>
        <div v-if="isCordova" class="scanner">
            <!--App-->
            <div class="mask"></div>
            <div class="scan_text">將鏡頭對準QRcode進行掃描</div>
            <button class="el-button back el-button--text" @click="finish">
                <span><img src="@/assets/images/top_bar_close_white.svg"></span>
            </button>
        </div>
    </div>
</template>


<script>
    import {QrcodeStream} from 'vue-qrcode-reader'
    import * as mutationTypes from "@/store/mutationTypes";

    export default {
        name: "CheckOutScan",
        components: {QrcodeStream},
        data() {
            return {
                isWebScan: false,
                isCordova: false,
                //相機背景
                bodyBgColor: null,
                appBgColor: null,
                //Line頻道 liff 開啟相機
                liffUrl: "https://liff.line.me/2008934720-dx73LUSg", //process.env.VUE_APP_LIFF_SCAN_URL, //Liff URL
                isLineChannel: this.$http.getLineAppOpen(), //判斷Line App開啟
                pageVisible: document.visibilityState === 'visible',  // 監聽當前畫面狀態 初始狀態
                supportsMediaDevices: false, //檢查裝置有沒有相機
                openScanType: this.$route.query.openScanType || '',
            }
        },
        created() {
            this.isCordova = this.$public.isCordova();
            this.startScan()
        },
        mounted() {
            // 添加 visibilitychange 監聽 畫面為裝置當前畫面
            if ((this.$http.getOS() === 'Android') && this.isLineChannel) {
                document.addEventListener('visibilitychange', this.handleVisibilityChange);
            }
        },
        destroyed() {
            // 移除 visibilitychange 監聽
            if ((this.$http.getOS() === 'Android') && this.isLineChannel) {
                document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            }

            //離開此頁面後不再監聽
            if (this.isCordova) {
                window.QRScanner.destroy(); // 隱藏相機 不要用destroy關閉相機 會把背景顏色變成透明
                //恢復之前的背景
                this.restoreBackground();
            }
        },
        methods: {
            //Line Liff監聽畫面為裝置當前畫面
            handleVisibilityChange() {
                const isVisible = document.visibilityState === 'visible';
                if (isVisible !== this.pageVisible) {
                    this.updatePageState(isVisible, 'visibilitychange');
                }
            },
            //Line Liff當前畫面判斷邏輯
            updatePageState(isVisible, source = '') {
                if (isVisible === this.pageVisible) {
                    return;
                }
                this.pageVisible = isVisible;
                if (isVisible) {
                    // 從背景底層回到當前畫面
                    let text = window.localStorage.getItem('qrcode');
                    window.localStorage.removeItem('qrcode');
                    if (text !== null && text !== 'null' && text !== '') {
                        this.onDecode(text);
                    }
                    // 其他恢復邏輯...
                }
            },
            async startScan() { //啟動相機
                let self = this
                //相機背景
                self.backupBackground();
                document.getElementById("app").style.backgroundColor = "transparent";
                document.querySelector('body').style.backgroundColor = "transparent";
                if (self.isCordova) { //App開啟
                    let permissions = window.cordova.plugins.permissions;
                    permissions.checkPermission(permissions.CAMERA, function (status) {
                        if (status.hasPermission) {
                            window.QRScanner.prepare(self.onPrepare);
                        } else {
                            permissions.requestPermission(permissions.CAMERA, self.success);
                        }
                    });
                } else { //網頁及Line App開啟
                    //取得裝置有沒有相機
                    this.supportsMediaDevices = navigator.mediaDevices;
                    if (this.supportsMediaDevices) {
                        //裝置有相機
                        if ((this.$http.getOS() === 'Android') && this.isLineChannel) {
                            //liff掃碼
                            localStorage.setItem("from", "Scan");
                            this.$liff.openWindow({
                                url: this.liffUrl, // 要開啟的網址
                                external: false // 是否使用外部瀏覽器開啟
                            });
                        } else {
                            //網頁掃碼
                            this.isWebScan = true;
                        }
                    } else {
                        //裝置沒有相機
                        alert("無法開啟相機.")
                    }
                }
            },
            success() {
                window.QRScanner.prepare(this.onPrepare);
            },
            onPrepare(err) {
                if (err) {
                    // eslint-disable-next-line no-console
                    console.log("onPrepare error :" + err._message);
                } else {
                    window.QRScanner.scan(this.onScan);

                    window.QRScanner.show(function (status) {
                        // eslint-disable-next-line no-console
                        console.log(status);
                    });
                }
            },
            /** 掃描 */
            onScan(err, result) {
                if (err) {
                    // eslint-disable-next-line no-console
                    this.finish();
                    return
                }

                if (result !== '' && result !== null) {
                    //掃描結果寫入暫存，返回後再由呼叫者自行從 sessionStorage 中取得結果
                    localStorage.setItem('cameraResult', result);
                    sessionStorage.setItem('cameraResult', result);
                    this.$store.commit('putScanResult', result);
                    this.finish();
                }
            },
            /** 關閉頁面，離開頁面時呼叫 */
            finish() {

                if (this.isCordova) {
                    // window.QRScanner.hide(); // 隱藏相機 不要用destroy關閉相機 會把背景顏色變成透明
                    window.QRScanner.destroy();
                    window.document.querySelector('body').style.backgroundColor = "#EEE";
                } else {
                    this.isWebScan = false;
                    if (this.openScanType !== '') {
                        localStorage.setItem('openScanType', this.openScanType);
                    } else {
                        localStorage.removeItem('openScanType');
                    }
                }

                this.$router.back();
            },
            //監聽vue-qrcode-reader錯誤
            onError(error) {
                console.error('QR Error:', error.name, "  Error message:", error.message);
                // 如果是 Wasm 相關，試清快取或 incognito 模式
            },
            onDecode(content) {
                localStorage.setItem('cameraResult', content); // 掃碼結果
                sessionStorage.setItem('cameraResult', content); // 掃碼結果
                this.$store.commit('putScanResult', content);
                this.finish();
            },
            async onInit(promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                    // eslint-disable-next-line no-console
                    this.$public.showNotify("找不到裝置", false);
                }
            },
            /* cordova 條用 */
            /** 備份背景 */
            backupBackground: function() {
                if (document.getElementById("app") !== null) {
                    this.appBgColor = document.getElementById("app").style.backgroundColor;
                }
                if (document.querySelector('body') !== null) {
                    this.bodyBgColor = document.querySelector('body').style.backgroundColor;
                }
            },

            /** 還原背景 */
            restoreBackground: function() {
                if (document.getElementById("app") !== null) {
                    document.getElementById("app").style.backgroundColor = this.appBgColor;
                }
                if (document.querySelector('body') !== null) {
                    document.querySelector('body').style.backgroundColor = this.bodyBgColor;
                }
            },
            /* 以上cordova調用 */
        },
    }
</script>

<style lang="less" scoped src="../../less/scan.less"/>